class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

function checkoutShop(shopLocation,selectedProducts){
  let baseURL = "";
  let shopURL = "";
  switch (shopLocation) {
        case "Clothes Mentor Pawleys Island South Carolina":
        baseURL = "https://cm-guinea-pig.myshopify.com";
        break;
        
        case "Clothes Mentor Aurora Illinois":
        baseURL = "https://clothes-mentor-aurora-il.myshopify.com";
        break;
        
        case "Clothes Mentor Upper Arlington Ohio":
        baseURL = "https://clothes-mentor-upper-arlington-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Fort Wayne Indiana":
        baseURL = "https://clothes-mentor-fort-wayne-in.myshopify.com";
        break;
        
        case "Clothes Mentor Maple Grove Minnesota":
        baseURL = "https://clothes-mentor-maple-grove-mn.myshopify.com";
        break;
        
        case "Clothes Mentor Orland Park Illinois":
        baseURL = "https://clothes-mentor-orland-park-il.myshopify.com";
        break;
        
        case "Clothes Mentor Fort Collins Co":
        baseURL = "https://clothes-mentor-fort-collins.myshopify.com";
        break;
        
        case "Clothes Mentor Edina Minnesota":
        baseURL = "https://clothes-mentor-edina-mn.myshopify.com";
        break;
        
        case "Clothes Mentor Burnsville Minnesota":
        baseURL = "https://clothes-mentor-burnsville-minnesota.myshopify.com";
        break;
        
        case "Clothes Mentor Crest Hill Illinois":
        baseURL = "https://clothes-mentor-crest-hill-il.myshopify.com";
        break;
        
        case "Clothes Mentor Eden Prairie Minnesota":
        baseURL = "https://clothes-mentor-eden-prairie-mn.myshopify.com";
        break;
        
        case "Clothes Mentor Wilmington North Carolina":
        baseURL = "https://clothes-mentor-wilmington-nc.myshopify.com";
        break;
        
        case "Clothes Mentor South Windsor Connecticut":
        baseURL = "https://clothes-mentor-south-windsor-ct.myshopify.com";
        break;
        
        case "Clothes Mentor Perrysburg Ohio":
        baseURL = "https://clothes-mentor-perrysburg-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Westerville Ohio":
        baseURL = "https://clothes-mentor-westerville-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Sylvania Ohio":
        baseURL = "https://clothes-mentor-sylvania-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Dublin Ohio":
        baseURL = "https://clothes-mentor-dublin-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Gahanna Ohio":
        baseURL = "https://clothes-mentor-gahanna-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Overland Park Kansas":
        baseURL = "https://clothes-mentor-overland-park-ks.myshopify.com";
        break;
        
        case "Clothes Mentor Littleton Colorado":
        baseURL = "https://clothes-mentor-littleton-co.myshopify.com";
        break;
        
        case "Clothes Mentor Lees Summit Missouri":
        baseURL = "https://clothes-mentor-lees-summit-mo.myshopify.com";
        break;
        
        case "Clothes Mentor Plano Texas":
        baseURL = "https://clothes-mentor-plano-texas.myshopify.com";
        break;
        
        case "Clothes Mentor Fargo North Dakota":
        baseURL = "https://clothes-mentor-fargo-nd.myshopify.com";
        break;
        
        case "Clothes Mentor Louisville Kentucky":
        baseURL = "https://cm-taylorsville.myshopify.com";
        break;
        
        case "Clothes Mentor Syracuse New York":
        baseURL = "https://clothes-mentor-syracuse-ny.myshopify.com";
        break;
        
        case "Clothes Mentor North Olmsted Ohio":
        baseURL = "https://clothes-mentor-north-olmstead-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Palm Harbor Florida":
        baseURL = "https://clothes-mentor-palm-harbor-fl.myshopify.com";
        break;
        
        case "Clothes Mentor Bismarck North Dakota":
        baseURL = "https://clothes-mentor-bismarck-nd.myshopify.com";
        break;
        
        case "Clothes Mentor Mishawaka Indiana":
        baseURL = "https://clothes-mentor-mishawaka-in.myshopify.com";
        break;
        
        case "Clothes Mentor Canton Ohio":
        baseURL = "https://clothes-mentor-canton-ohio.myshopify.com";
        break;
        
        case "Clothes Mentor Novi Michigan":
        baseURL = "https://clothes-mentor-novi-mi.myshopify.com";
        break;
        
        case "Clothes Mentor Charlotte Midtown North Carolina":
        baseURL = "https://clothes-mentor-charlotte-nc.myshopify.com";
        break;
        
        case "Clothes Mentor Greenville South Carolina":
        baseURL = "https://clothes-mentor-greenville-sc.myshopify.com";
        break;
        
        case "Clothes Mentor North Richland Hills Texas":
        baseURL = "https://clothes-mentor-north-richland-hills-tx.myshopify.com";
        break;
        
        case "Clothes Mentor Highland Village Texas":
        baseURL = "https://clothes-mentor-highland-village-texas.myshopify.com";
        break;
        
        case "Clothes Mentor Ft Myers Florida":
        baseURL = "https://clothes-mentor-ft-myers-fl.myshopify.com";
        break;
        
        case "Clothes Mentor San Antonio North Star Texas":
        baseURL = "https://clothes-mentor-san-antonio-north-star-tx.myshopify.com";
        break;
        
        case "Clothes Mentor San Antonio Culebra Texas":
        baseURL = "https://clothes-mentor-culebra-san-antonio-tx.myshopify.com";
        break;
        
        case "Clothes Mentor Buford Georgia":
        baseURL = "https://clothes-mentor-buford-ga.myshopify.com";
        break;
        
        case "Clothes Mentor Short Pump Virginia":
        baseURL = "https://clothes-mentor-short-pump-va.myshopify.com";
        break;
        
        case "Clothes Mentor West Chester Pennsylvania":
        baseURL = "https://clothes-mentor-west-chester-penn.myshopify.com";
        break;
        
        case "Clothes Mentor Garland Texas":
        baseURL = "https://clothes-mentor-garland-tx.myshopify.com";
        break;
        
        case "Clothes Mentor Bloomington Illinois":
        baseURL = "https://clothes-mentor-bloomington-il.myshopify.com";
        break;
        
        case "Clothes Mentor Fort Worth Hulen Texas":
        baseURL = "https://clothes-mentor-ft-worth-tx.myshopify.comx";
        break;
        
        case "Clothes Mentor Tyler Texas":
        baseURL = "https://clothes-mentor-tyler-tx.myshopify.com";
        break;
        
        case "Clothes Mentor Alliance Ft. Worth Texas":
        baseURL = "https://clothes-mentor-ft-worth.myshopify.com";
        break;
        
        case "Clothes Mentor Strongsville Ohio":
        baseURL = "https://clothes-mentor-strongsville-ohio.myshopify.com";
        break;
        
        case "Clothes Mentor West Chester Ohio":
        baseURL = "https://clothes-mentor-west-chester-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Anderson Ohio":
        baseURL = "https://clothes-mentor-anderson-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Cincinnati Fields Ertel Ohio":
        baseURL = "https://clothes-mentor-fields-ertel-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Hyde Park Cincinnati Ohio":
        baseURL = "https://clothes-mentor-hyde-park-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Mayfield Heights Ohio":
        baseURL = "https://clothes-mentor-mayfield-heights-ohio.myshopify.com";
        break;
        
        case "Clothes Mentor Clarksville Tennessee":
        baseURL = "https://clothes-mentor-clarksville-tennessee.myshopify.com";
        break;
        
        case "Clothes Mentor Fayetteville North Carolina":
        baseURL = "https://clothes-mentor-fayetteville-north-carolina.myshopify.com";
        break;
        
        case "Clothes Mentor Newport News Virginia":
        baseURL = "https://clothes-mentor-newport-news-va.myshopify.com";
        break;
        
        case "Clothes Mentor Bridgeville Pennsylvania":
        baseURL = "https://clothes-mentor-bridgeville-pa.myshopify.com";
        break;
        
        case "Clothes Mentor St. Louis Missouri":
        baseURL = "https://clothes-mentor-st-louis-mo.myshopify.com";
        break;
        
        case "Clothes Mentor Fredricksburg Virginia":
        baseURL = "https://clothes-mentor-fredricksburg-va.myshopify.com";
        break;
        
        case "Clothes Mentor Savannah Georgia":
        baseURL = "https://clothes-mentor-savannah-ga.myshopify.com";
        break;
        
        case "Clothes Mentor Charlotte Arboretum NC":
        baseURL = "https://clothes-mentor-charlotte-arboretum-nc.myshopify.com";
        break;
        
        case "Clothes Mentor Columbia South Carolina":
        baseURL = "https://clothes-mentor-columbia-sc.myshopify.com";
        break;
        
        case "Clothes Mentor Spartanburg South Carolina":
        baseURL = "https://clothes-mentor-spartanburg-sc.myshopify.com";
        break;
        
        case "Clothes Mentor Virginia Beach Virginia":
        baseURL = "https://clothes-mentor-virginia-beach-va.myshopify.com";
        break;
        
        case "Clothes Mentor Suffolk Virginia":
        baseURL = "https://clothes-mentor-suffolk-va.myshopify.com";
        break;
        
        case "Clothes Mentor Asheville North Carolina":
        baseURL = "https://clothes-mentor-asheville.myshopify.com";
        break;
        
        case "Clothes Mentor Lone Tree Colorado":
        baseURL = "https://clothes-mentor-lone-tree-co.myshopify.com";
        break;
        
        case "Clothes Mentor Springfield Pennsylvania":
        baseURL = "https://clothes-mentor-springfield-pa.myshopify.com";
        break;
        
        case "Clothes Mentor Peoria Illinois":
        baseURL = "https://clothes-mentor-peoria-il.myshopify.com";
        break;
        
        case "Clothes Mentor Brookfield Wisconsin":
        baseURL = "https://clothes-mentor-brookfield-wi.myshopify.com";
        break;
        
        case "Clothes Mentor Chapel Hill North Carolina":
        baseURL = "https://clothes-mentor-chapel-hill-nc.myshopify.com";
        break;
        
        case "Clothes Mentor Springfield Illinois":
        baseURL = "https://clothes-mentor-springfield-il.myshopify.com";
        break;
        
        case "Clothes Mentor Raleigh North Carolina":
        baseURL = "https://clothes-mentor-raleigh-nc.myshopify.com";
        break;
        
        case "Clothes Mentor Ardmore Pennsylvania":
        baseURL = "https://clothes-mentor-ardmore-pa.myshopify.com";
        break;
        
        case "Clothes Mentor Columbus Georgia":
        baseURL = "https://clothes-mentor-columbus-ga.myshopify.com";
        break;
        
        case "Clothes Mentor Fishers Indiana":
        baseURL = "https://clothes-mentor-fishers-in.myshopify.com";
        break;
        
        case "Clothes Mentor Cordova Tennessee":
        baseURL = "https://clothes-mentor-cordova-tn.myshopify.com";
        break;
        
        case "Clothes Mentor Rapid City South Dakota":
        baseURL = "https://clothes-mentor-rapid-city-sd.myshopify.com";
        break;
        
        case "Clothes Mentor Plymouth Meeting Pennsylvania":
        baseURL = "https://clothes-mentor-plymouth-meeting-pa.myshopify.com";
        break;
        
        case "Clothes Mentor Edmond Oklahoma":
        baseURL = "https://clothes-mentor-edmond-ok.myshopify.com";
        break;
        
        case "Clothes Mentor Jonesboro Georgia":
        baseURL = "https://clothes-mentor-jonesboro-ga.myshopify.com";
        break;
        
        case "Clothes Mentor Arlington Heights Illinois":
        baseURL = "https://clothes-mentor-arlington-heights-il.myshopify.com";
        break;
        
        case "Clothes Mentor Athens Georgia":
        baseURL = "https://clothes-mentor-athens-ga.myshopify.com";
        break;
        
        case "Clothes Mentor North Little Rock Arkansas":
        baseURL = "https://clothes-mentor-north-little-rock-ar.myshopify.com";
        break;
        
        case "Clothes Mentor Little Rock Arkansas":
        baseURL = "https://clothes-mentor-little-rock-ar.myshopify.com";
        break;
        
        case "Clothes Mentor Portage Michigan":
        baseURL = "https://clothes-mentor-portage-mi.myshopify.com";
        break;
        
        case "Clothes Mentor Rockhill South Carolina":
        baseURL = "https://clothes-mentor-rockhill-sc.myshopify.com";
        break;
        
        case "Clothes Mentor Arlington Texas":
        baseURL = "https://clothes-mentor-arlington-tx.myshopify.com";
        break;
        
        case "Clothes Mentor Peoria Arizona":
        baseURL = "https://clothes-mentor-peoria-az.myshopify.com";
        break;
        
        case "Clothes Mentor Sarasota Florida":
        baseURL = "https://clothes-mentor-sarasota-fl.myshopify.com";
        break;
        
        case "Clothes Mentor Selma Texas":
        baseURL = "https://clothes-mentor-selma-texas.myshopify.com";
        break;
        
        case "Clothes Mentor Jacksonville Florida":
        baseURL = "https://clothes-mentor-jacksonville-baymeadows-fl.myshopify.com";
        break;
        
        case "Clothes Mentor Sugar Land Texas":
        baseURL = "https://clothes-mentor-sugarland-tx.myshopify.com";
        break;
        
        case "Clothes Mentor Rochester Hills Michigan":
        baseURL = "https://clothes-mentor-rochester-hills-mi.myshopify.com";
        break;
        
        case "Clothes Mentor Ontario Ohio":
        baseURL = "https://clothes-mentor-ontario-oh.myshopify.com";
        break;
        
        case "Clothes Mentor Ellisville Missouri":
        baseURL = "https://clothes-mentor-ellisville-mo.myshopify.com";
        break;
        
        case "Clothes Mentor Liberty Missouri":
        baseURL = "https://clothes-mentor-liberty-mo.myshopify.com";
        break;
        
        case "Clothes Mentor Ann Arbor Michigan":
        baseURL = "https://clothes-mentor-ann-arbor-mi.myshopify.com";
        break;
        
		case "Clothes Mentor Avondale Arizona":
        baseURL = "https://clothes-mentor-avondale-az.myshopify.com";
        break;
        
		case "Clothes Mentor Goshen Indiana":
        baseURL = "https://clothes-mentor-goshen-in.myshopify.com";
        break;
        		
		case "Clothes Mentor Hobe Sound Florida":
        baseURL = "https://clothes-mentor-hobe-sound-fl.myshopify.com";
        break;
        
		case "Clothes Mentor Minnetonka Minnesota":
        baseURL = "https://clothes-mentor-minnetonka-minnesota.myshopify.com";
        break;
        
		case "Clothes Mentor Plantation Florida":
        baseURL = "https://clothes-mentor-plantation-fl.myshopify.com";
        break;
        
		case "Clothes Mentor Sandusky Ohio":
        baseURL = "https://clothes-mentor-sandusky-oh.myshopify.com";
        break;
        
		case "Clothes Mentor South Oklahoma City Oklahoma":
        baseURL = "https://clothes-mentor-south-oklahoma-city-ok.myshopify.com";
        break;
        
        
        case "Clothes Mentor St. Cloud Minnesota":
        baseURL = "https://clothes-mentor-st-cloud-mn.myshopify.com";
        break;

        case "Clothes Mentor Syracuse New York":
        baseURL = "https://clothes-mentor-syracuse-ny.myshopify.com";
        break;

        case "Clothes Mentor Tyler Texas":
        baseURL = "https://clothes-mentor-tyler-tx.myshopify.com";
        break;
        

        case "Clothes Mentor Upper Arlington Ohio":
        baseURL = "https://clothes-mentor-upper-arlington-oh.myshopify.com";
        break;
        

        case "Clothes Mentor Virginia Beach Virginia":
        baseURL = "https://clothes-mentor-virginia-beach-va.myshopify.com";
        break;

        case "Clothes Mentor Waldorf Maryland":
        baseURL = "https://clothes-mentor-waldorf-md.myshopify.com";
        break;

        case "Clothes Mentor St Matthews Louisville Kentucky":
        baseURL = "https://cm-st-matthews.myshopify.com";
        break;

        case "Clothes Mentor Knoxville Turkey Creek Tennessee":
        baseURL = "https://clothes-mentor-turkey-creek.myshopify.com";
        break;        

        case "Clothes Mentor Allentown Pennsylvania":
        baseURL = "https://clothes-mentor-lehigh-valley-pa.myshopify.com";
        break;        

        case "Clothes Mentor Altamonte Springs Florida":
        baseURL = "https://clothes-mentor-altamonte-springs-fl.myshopify.com";
        break;  
        
        case "Clothes Mentor Beavercreek Ohio":
        baseURL = "https://clothes-mentor-beaver-creek-oh.myshopify.com";
        break;       

        case "Clothes Mentor Katy Texas":
        baseURL = "https://clothes-mentor-katy-tx.myshopify.com";
        break;       

        case "Clothes Mentor Omaha Nebraska":
        baseURL = "https://clothes-mentor-omaha-ne.myshopify.com";
        break;            


        case "Clothes Mentor McKinney Texas":
        baseURL = "https://clothes-mentor-mckinney-tx.myshopify.com";
        break;            

        case "Clothes Mentor Florence Kentucky":
        baseURL = "https://clothes-mentor-florence-ky.myshopify.com";
        break;   

        case "Clothes Mentor Ocoee Florida":
        baseURL = "https://clothes-mentor-ocoee-florida-2.myshopify.com";
        break;       

        case "Clothes Mentor Raleigh North Carolina":
        baseURL = "https://clothes-mentor-raleigh-north-carolina.myshopify.com";
        break;   

        case "Clothes Mentor Rochester Minnesota":
        baseURL = "https://clothes-mentor-rochester-mn.myshopify.com";
        break;   

        case "Clothes Mentor Round Rock Texas":
        baseURL = "https://clothes-mentor-round-rock-tx.myshopify.com";
        break;         
        
        default:
            baseURL = "##404-error##Update_Agg-Site.Js.com##";
            break;
    }
    shopURL = baseURL + "/pages/AddToCart?productIds="+ selectedProducts;
    window.location.href = shopURL;
    console.log('Redirecting to '+ shopURL);
}

